import * as Types from 'src/state/gql/_types';
import { AsyncAction, Context } from "src/state/_types";
import { pipe, debounce } from 'overmind'
import { handleGraphqQLErrorResponse } from "../gql/utils";

export const checkUserEmail: AsyncAction<string|undefined,boolean> = pipe(
    debounce(250),
    async ({effects}: Context, email) => {
        if (!email) return true;
        let { items } = await effects.gql.queries.CheckUserEmail({email})
        return !!!items.length
    }
)

export const findItems: AsyncAction<Types.FindUsersQueryVariables, Types.FindUsersQuery['items']> = async ({state, effects}, payload) => {
    try {
        let { items } = await effects.gql.queries.GetUsers(payload)
        return items;
    } catch (e: any) {
        state.users.errors = handleGraphqQLErrorResponse(e);
        return [];
    }

}